import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
// import _isEqual from 'lodash/isEqual'
import { globalActions } from 'redux/global/global.slice';
import { RootState, useAppDispatch } from 'redux/store';
import {
    getConversation,
    getConversation_conversations_data_messages,
    getConversation_conversations_data_messages_elements,
    getConversationVariables,
    getSingleConversationVariables,
} from '../../../__generated__/getConversation';
import {
    DEFAULT_CONVERSATION_SIZE,
    DISPLAY_FLOATING_BUTTON,
    ENABLED_SHOW_MORE_STYLES,
    FEEDBACK_VALUES,
    IConversation,
    IConversationState,
    IElements,
    IMessages,
} from '../index';
import {
    LanguageCode,
    MessageRoleEnum,
    MessageScopeEnum,
    MessageTypeEnum,
    MessageVisibleEnum,
    StyleConversationStatusEnum,
    StyleMessageElementTypeEnum,
    UpdateStyleConversationInput,
} from '../../../__generated__/globalTypes';
import { TRACK_EVENT, trackEvent } from '../../../utils/analytics';
import { useParams } from 'react-router-dom';
import { useLazyQuery, useMutation } from '@apollo/client';
import { createConversation, createConversationVariables } from '../../../__generated__/createConversation';
import { CREATE_CONVERSATION } from 'graph_ql/chat/mutation.gql';
import utils from '../../../utils/utils';
import { useSelector } from 'react-redux';
import { differenceBy } from 'lodash';
import { useQueryParams } from '../../../hooks/useQueryParams';
import { GET_CONSUMER_CONVERSATION, GET_CONVERSATION, GET_SINGLE_CONVERSATION } from 'graph_ql/chat/queries.gql';
import {
    getConsumerConversations,
    getConsumerConversationsVariables,
} from '../../../__generated__/getConsumerConversations';
import { User } from 'component/stylist_profile_header/types';
import constant, { LOCAL_STORAGE_KEY } from '../../../utils/constant';
import { WIDGET_CONSTANTS } from '../../../constants';
import { getProductTrackingDataForAmira } from '../../../utils/trackUtils';
import {
    updateIsInitiateNewChat,
    updateCurrentConversationId,
    updateConversations,
    updateMessages as updateReduxMessages,
    updateConversationState,
    removeConversationState,
} from '../../../redux/chat/chat.slice';

import { store } from '../../../redux/store';

import { useFeedbackCollector } from './useFeedbackCollector';
import { useLoaderStyles } from 'hooks/useLoaderStyles';

export const NEW_THREAD = 'new';
export const ARCHIVED_THREAD = 'archivedThread';
export const STYLIST = 'stylist';
export const ENABLE_ENGAGING_SLIDER = true;
interface ChatContextProps {
    conversation: IConversation | null;
    messages: IMessages[];
    // setMessages: React.Dispatch<React.SetStateAction<IMessages[]>>;
    message: string;
    setMessage: React.Dispatch<React.SetStateAction<string>>;
    showDynamicItemDetail: any;
    setShowDynamicItemDetail: React.Dispatch<React.SetStateAction<any>>;
    expandedMessageTaffiIds: string[];
    addExpandedMessageTaffiId: (taffiId: string) => void;
    isExpandedMessage: (message: getConversation_conversations_data_messages) => boolean;
    isReceivedAssistantMessage: boolean;
    setIsReceivedAssistantMessage: React.Dispatch<React.SetStateAction<boolean>>;
    selectedElement: any;
    setSelectedElement: React.Dispatch<React.SetStateAction<any>>;
    showStylePreview: boolean;
    setShowStylePreview: React.Dispatch<React.SetStateAction<boolean>>;
    isUnlockExpProcessing: boolean;
    setIsUnlockExpProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    openAuthPopup: () => void;
    startRecommendTime: React.MutableRefObject<number>;
    messageContainerRef: React.RefObject<HTMLDivElement>;
    handleShowMore: (
        item: getConversation_conversations_data_messages,
        element: getConversation_conversations_data_messages_elements,
    ) => void;
    answerMutation: any;
    updateFeedbackButton: (
        item: getConversation_conversations_data_messages,
        element: getConversation_conversations_data_messages_elements,
    ) => void;
    pageNum: React.MutableRefObject<number>;
    chatWindowHeight: number;
    setChatWindowHeight: React.Dispatch<React.SetStateAction<number>>;
    setElements: (nextMessage: getConversation_conversations_data_messages) => IMessages;
    pendingElements: IElements[];
    setPendingElements: React.Dispatch<React.SetStateAction<IElements[]>>;
    pendingMessages: IMessages[];
    setPendingMessages: React.Dispatch<React.SetStateAction<IMessages[]>>;
    scrollTopRef: React.MutableRefObject<number>;
    renderPreviousConversations: (scrollTop: boolean) => void;
    getConversationFn: any;
    getSingleConversationFn: any;
    messageLoading: boolean;
    handleOnComplete: (response: any, fetch: boolean) => void;
    handleOnCompleteForStylist: (response: any, fetch: boolean) => void;
    consumer: User | null;
    setConsumer: React.Dispatch<React.SetStateAction<User | null>>;
    localUser: any;
    setLocalUser: React.Dispatch<React.SetStateAction<any>>;
    user: any | null;
    isInitiateNewConveration: any | null;
    userName: string;
    isUserAuthenticated: boolean;
    updateLocalUser: (data: any) => void;
    getConversationOnScroll: () => void;
    restoredPosition: boolean;
    setRestoredPosition: React.Dispatch<React.SetStateAction<boolean>>;
    getConsumerConversation: any;
    consumerMessageLoading: boolean;
    updateChat: (newConversation: IConversation | null, newMessages: IMessages[], fetch: boolean) => void;
    sendMessage: any;
    handleAnalytics: (event: string, message?: any, element?: any, child?: any) => void;
    messagesWithPendingMessage: IMessages[];
    setMessagesWithPendingMessage: React.Dispatch<React.SetStateAction<IMessages[]>>;
    pendingMessageLoading: boolean;
    setPendingMessageLoading: React.Dispatch<React.SetStateAction<boolean>>;
    scrollToBottomOnMessageDisplay: () => void;
    scrollToBottom: () => void;
    handleMessageDisplay: () => void;
    updateMessagesWithElements: () => void;
    updateMessages: () => void;
    displayFloatingButton: boolean;
    setDisplayFloatingButton: React.Dispatch<React.SetStateAction<boolean>>;
    handleScroll: () => void;
    resetPageNum: () => void;
    updateConversationForNewChat: (conversation: IConversation | null) => void;
    canFetchConversationList: () => boolean;
    isNewUserFirstMessage: () => boolean;
    isConversationDone: boolean;
    conversationState: IConversationState | null;
    getReduxStoreValue: any;
    updateSourceConversationId: (data: any) => void;
    isCollectingFeedbackReason: boolean;
    setIsCollectingFeedbackReason: React.Dispatch<React.SetStateAction<boolean>>;
    feedbackMessageRef: React.MutableRefObject<IMessages | null>;
    requestParameters: string;
    setRequestParameters: React.Dispatch<React.SetStateAction<string>>;
    isEngageSliderPreviewOpen: boolean;
    setIsEngageSliderPreviewOpen: React.Dispatch<React.SetStateAction<boolean>>;
    isEngageSliderPreviewOpenRef: React.MutableRefObject<boolean>;
    isEngagingSliderDisplay: (message?: any) => boolean;
    listStyles: any;
    canEngagingSliderDisplay: boolean;
    waitingRecommendationMessage: React.MutableRefObject<any>;
}

const ChatContext = createContext<ChatContextProps | undefined>(undefined);

interface ChatProviderProps {
    children: React.ReactNode;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({ children }) => {
    const { isCollectingFeedbackReason, setIsCollectingFeedbackReason, feedbackMessageRef } = useFeedbackCollector();
    const [message, setMessage] = useState<string>('');
    const [showDynamicItemDetail, setShowDynamicItemDetail] = useState<any>(null);
    const [requestParameters, setRequestParameters] = useState<string>('');
    const [expandedMessageTaffiIds, setExpandedMessageTaffiIds] = useState<string[]>([]);
    const [isReceivedAssistantMessage, setIsReceivedAssistantMessage] = useState(false);
    const [selectedElement, setSelectedElement] = useState({});
    const [showStylePreview, setShowStylePreview] = useState(false);
    const [isUnlockExpProcessing, setIsUnlockExpProcessing] = useState<boolean>(false);
    const messageContainerRef = useRef<HTMLDivElement>(null);
    const startRecommendTime = useRef(new Date().getTime());
    const pageNum = useRef(0);
    const storeId = useSelector((state: RootState) => state.widget.store?.id);
    const enableEngagingSlider = useSelector((state: RootState) => state.widget.store?.enableEngagingSlider);
    const selectedQuestion = useSelector((state: RootState) => state.widget?.selectedQuestion);
    const dispatch = useAppDispatch();
    const [chatWindowHeight, setChatWindowHeight] = useState(0);
    const [pendingElements, setPendingElements] = useState<IElements[] | []>([]);
    const [pendingMessages, setPendingMessages] = useState<IMessages[]>([]); //pending messages is the stack to store the messages to be prinited once received from the api
    const [restoredPosition, setRestoredPosition] = useState<boolean>(false);
    const scrollTopRef = useRef<number>(0);
    const queryParams = useQueryParams();
    const [consumer, setConsumer] = useState<User | null>(null);
    const [messagesWithPendingMessage, setMessagesWithPendingMessage] = useState<IMessages[]>([]); //if there are pending messages, then pick one from the pending message and keep it here. Then when the state is updated, the setmessages has been invoked from useeffect
    const [pendingMessageLoading, setPendingMessageLoading] = useState(false);
    const [displayFloatingButton, setDisplayFloatingButton] = useState<boolean>(false);
    const isDisplayArchivedThread = useSelector((state: RootState) => state.chat.isDisplayArchivedThread);
    const archivedThreadDate = useSelector((state: RootState) => state.chat.archivedThreadDate);
    const conversations = useSelector((state: RootState) => state.chat.conversations);
    const currentConversationId = useSelector((state: RootState) => state.chat.currentConversationId);
    const currentConversationIdRef = useRef(null);
    const [isEngageSliderPreviewOpen, setIsEngageSliderPreviewOpen] = useState(false);
    const isEngageSliderPreviewOpenRef = useRef(isEngageSliderPreviewOpen);
    const waitingRecommendationMessage = useRef<any>({});

    useEffect(() => {
        isEngageSliderPreviewOpenRef.current = isEngageSliderPreviewOpen;
    }, [isEngageSliderPreviewOpen]);
    useEffect(() => {
        currentConversationIdRef.current = currentConversationId;
        //scroll to bottom whenever user switches to already loaded conversations.
        setTimeout(() => {
            if (messageContainerRef.current)
                messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
        }, 0);
    }, [currentConversationId]);
    const conversationStates = useSelector((state: RootState) => state.chat.conversationState);
    const conversation = useMemo(() => {
        if (isDisplayArchivedThread) return conversations[ARCHIVED_THREAD] ?? null;
        if (currentConversationId) return conversations[currentConversationId] ?? null;
        return null;
    }, [isDisplayArchivedThread, conversations, currentConversationId]);
    const conversationState = useMemo(() => {
        if (isDisplayArchivedThread) return conversationStates[ARCHIVED_THREAD] ?? null;
        if (currentConversationId) return conversationStates[currentConversationId] ?? null;
        return conversationStates[NEW_THREAD] ?? null;
    }, [isDisplayArchivedThread, conversationStates, currentConversationId]);

    const reduxMessages = useSelector((state: RootState) => state.chat.messages);
    const reduxMessagesRef = useRef(reduxMessages);
    const isMessagePrintingRef = useRef(isReceivedAssistantMessage);
    const conversationStateRef = useRef(conversationState);

    useEffect(() => {
        conversationStateRef.current = conversationState;
    }, [conversationState]);
    useEffect(() => {
        reduxMessagesRef.current = reduxMessages;
    }, [reduxMessages]);
    useEffect(() => {
        isMessagePrintingRef.current = isReceivedAssistantMessage;
    }, [isReceivedAssistantMessage]);

    const messages = useMemo(() => {
        if (isDisplayArchivedThread) return reduxMessages[ARCHIVED_THREAD] ?? [];
        if (currentConversationId) return reduxMessages[currentConversationId] ?? [];
        return reduxMessages[NEW_THREAD] ?? [];
    }, [isDisplayArchivedThread, currentConversationId, reduxMessages]);
    const messagesRef = useRef(messages);
    useEffect(() => {
        messagesRef.current = messages;
    }, [messages]);

    const { userName } = useParams<{ userName: string }>();
    const isStylistView = Boolean(userName);
    const me = useSelector((state: RootState) => state.userDetail.me);
    const localUserStr = localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY);
    const [localUser, setLocalUser] = useState(localUserStr ? JSON.parse(localUserStr) : null);
    const user = useMemo(() => me || localUser, [me, localUser]);
    const isUserAuthenticated = !!me;
    const updateLocalUser = useCallback(
        (data) => {
            if (!isUserAuthenticated) {
                const updatedLocalUser = { ...localUser, ...data };
                setLocalUser(updatedLocalUser);
                localStorage.setItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY, JSON.stringify(updatedLocalUser));
            }
        },
        [isUserAuthenticated, localUser, setLocalUser],
    );

    useEffect(() => {
        if (!user) {
            const refetchLocalUser = () => {
                const localUserStr = localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY);
                if (localUserStr) {
                    setLocalUser(JSON.parse(localUserStr));
                } else {
                    setTimeout(() => {
                        refetchLocalUser();
                    }, 500);
                }
            };
            refetchLocalUser();
        }
    }, [user, me, isUserAuthenticated, setLocalUser]);

    const [answerMutation] = useMutation<createConversation, createConversationVariables>(CREATE_CONVERSATION, {
        context: {
            allowAnonymousAuth: true,
        },
        onError(error) {
            console.error('Create Failed: ', error);
        },
    });

    const [getConversationFn, { loading: messageLoading }] = useLazyQuery<getConversation, getConversationVariables>(
        GET_CONVERSATION,
        {
            context: {
                allowAnonymousAuth: true,
            },
            fetchPolicy: 'cache-and-network',
            nextFetchPolicy: 'standby',
            onCompleted(response) {
                handleOnComplete(response, true);
            },
        },
    );

    const [getSingleConversationFn] = useLazyQuery<getConversation, getSingleConversationVariables>(
        GET_SINGLE_CONVERSATION,
        {
            context: {
                allowAnonymousAuth: true,
            },
            fetchPolicy: 'cache-and-network',
            nextFetchPolicy: 'standby',
            onCompleted(response) {
                handleOnComplete(response, true, true);
            },
        },
    );

    const [getConsumerConversation, { loading: consumerMessageLoading }] = useLazyQuery<
        getConsumerConversations,
        getConsumerConversationsVariables
    >(GET_CONSUMER_CONVERSATION, {
        context: {
            allowAnonymousAuth: true,
        },
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'standby',
        onCompleted(response) {
            handleOnCompleteForStylist(response, true);
        },
    });

    const addExpandedMessageTaffiId = (taffiId: string) => {
        setExpandedMessageTaffiIds((prevValues) => [...prevValues, taffiId]);
    };

    const isExpandedMessage = (message: getConversation_conversations_data_messages) => {
        return message.taffiId ? expandedMessageTaffiIds.includes(message.taffiId) : false;
    };

    const openAuthPopup = () => {
        dispatch(globalActions.setShowAuthPopup(true));
        setIsUnlockExpProcessing(false);
    };

    const handleAnalytics = useCallback(
        (event: string, message = {} as any, element = {} as any, child = null as any) => {
            const userInfo = {
                userId: user?.id,
                userType: user?.userType,
                email: user?.email,
                gender: user?.gender,
                name: user?.firstName,
            };
            const assistantSource = localStorage.getItem(WIDGET_CONSTANTS.STYLE_ASSISTANT_SOURCE);
            const sourceConversationId = localStorage.getItem(WIDGET_CONSTANTS.STYLE_ASSISTANT_SOURCE_CONVERSATION);
            const lastMsg = conversation?.messages[conversation?.messages.length - 1];
            const hasQuestionSource =
                sourceConversationId === NEW_THREAD || lastMsg?.conversationId === sourceConversationId;
            const language = message?.language || conversation?.language;
            const analyticsParams = {
                ...userInfo,
                conversationId: message?.conversationId,
                messageId: message?.id,
                language,
                ...(child
                    ? {
                        contextType: element?.productType,
                        contextId: element?.productId,
                        contextTaffiId: element?.productTaffiId,
                        productId: child?.productId,
                        productTaffiId: child?.productTaffiId,
                        productType: child?.productType,
                        productUrl: child?.url,
                    }
                    : {
                        productId: element?.productId,
                        productTaffiId: element?.productTaffiId,
                        productType: element?.productType,
                        productUrl: element?.url,
                    }),
                ...(utils.isAppInWidgetMode() && hasQuestionSource && { source: assistantSource }),
            };
            if (!ENABLED_SHOW_MORE_STYLES) {
                analyticsParams.styleCardType = 'slider';
            }
            switch (event) {
            case TRACK_EVENT.STYLE_CHAT_PRODUCT_CLICKED:
                trackEvent(TRACK_EVENT.STYLE_CHAT_PRODUCT_CLICKED, analyticsParams);
                break;
            case TRACK_EVENT.STYLE_CHAT_PRODUCT_IMAGE_CLICKED:
                trackEvent(TRACK_EVENT.STYLE_CHAT_PRODUCT_IMAGE_CLICKED, analyticsParams);
                break;
            case TRACK_EVENT.STYLE_CHAT_CONNECT_TO_STYLIST:
                trackEvent(TRACK_EVENT.STYLE_CHAT_CONNECT_TO_STYLIST, {
                    ...userInfo,
                    conversationId: message?.conversationId,
                    messageId: message?.id,
                    language,
                    ...(utils.isAppInWidgetMode() && hasQuestionSource && { source: assistantSource }),
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_PRODUCT_DISPLAYED:
                const endRecommendTime = new Date().getTime();
                const timeTaken = (endRecommendTime - startRecommendTime.current) / 1000;
                const { messageId, ...restParams } = analyticsParams;
                const userWithAuthStatus = {
                    ...user,
                    isUserAuthenticated,
                };
                trackEvent(event, {
                    ...restParams,
                    messageTaffiId: message?.taffiId,
                    conversationId: message?.conversationId,
                    timeTaken,
                    ...getProductTrackingDataForAmira(userWithAuthStatus, element),
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_SHOW_MORE_STYLES_CLICKED:
                trackEvent(event, {
                    ...userInfo,
                    conversationId: message?.conversationId,
                    language,
                    ...(utils.isAppInWidgetMode() && hasQuestionSource && { source: assistantSource }),
                    ...(ENABLED_SHOW_MORE_STYLES ? {} : { styleCardType: 'slider' }),
                });
                break;

            case TRACK_EVENT.STYLE_CHAT_TRENDING_QUESTION_CLICKED:
                trackEvent(TRACK_EVENT.STYLE_CHAT_TRENDING_QUESTION_CLICKED, {
                    ...userInfo,
                    language,
                    trendingQuestion: message?.trendingQuestion,
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_ACCESS_OPTION_CLICKED:
                trackEvent(event, {
                    ...userInfo,
                    type: message?.type,
                    conversationId: message?.conversationId,
                    messageTaffiId: message?.taffiId,
                    language,
                    ...(utils.isAppInWidgetMode() &&
                            selectedQuestion && { source: WIDGET_CONSTANTS.WIDGET_QUESTION_POPUP }),
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_DESCRIPTION_ACTION:
                trackEvent(event, {
                    ...analyticsParams,
                    messageTaffiId: message?.taffiId,
                    actionType: message?.actionType,
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_OTHER_OPTION_CLICKED:
                trackEvent(TRACK_EVENT.STYLE_CHAT_OTHER_OPTION_CLICKED, {
                    ...userInfo,
                    conversationId: message?.conversationId,
                    messageId: message?.id,
                    messageTaffiId: message?.taffiId,
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_FEEDBACK_YES_CLICKED:
                trackEvent(TRACK_EVENT.STYLE_CHAT_FEEDBACK_YES_CLICKED, {
                    ...userInfo,
                    conversationId: message?.conversationId,
                    messageId: message?.id,
                    messageTaffiId: message?.taffiId,
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_FEEDBACK_NO_CLICKED:
                trackEvent(TRACK_EVENT.STYLE_CHAT_FEEDBACK_NO_CLICKED, {
                    ...userInfo,
                    conversationId: message?.conversationId,
                    messageId: message?.id,
                    messageTaffiId: message?.taffiId,
                    feedbackReason: message?.feedbackReason,
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_CREATE_PROFILE_POPUP:
                trackEvent(event, {
                    ...analyticsParams,
                    messageTaffiId: message?.taffiId,
                    state: message?.createProfileState,
                    openedFrom: message?.createProfileOpenedFrom,
                    action: message?.createProfileAction,
                });
                break;
            case TRACK_EVENT.STYLE_CHAT_QUIZ_POPUP_BUTTON_DISPLAYED:
            case TRACK_EVENT.STYLE_CHAT_QUIZ_POPUP_BUTTON_CLICKED:
            case TRACK_EVENT.STYLE_CHAT_QUIZ_HANGER_BUTTON_CLICKED:
            case TRACK_EVENT.STYLE_CHAT_QUIZ_POPUP_BUTTON_CLOSED:
                trackEvent(event, {
                    ...userInfo,
                    conversationId: conversation?.id,
                });
                break;
            default:
                break;
            }
        },
        [user, conversation, selectedQuestion, isUserAuthenticated, startRecommendTime],
    );

    const handleStylistAnalytics = useCallback(
        (event: string, conversation = {} as any) => {
            const consumerInfo = {
                userId: consumer?.id,
                userEmail: consumer?.email,
                userGender: consumer?.gender,
            };
            const stylistInfo = {
                stylistId: user?.id,
                stylistEmail: user?.email,
            };

            const analyticsParams = {
                ...consumerInfo,
                ...stylistInfo,
                conversationId: conversation?.id,
            };
            switch (event) {
            case TRACK_EVENT.STYLE_CHAT_STYLIST_VIEW:
                trackEvent(event, analyticsParams);
                break;
            default:
                break;
            }
        },
        [consumer, user],
    );

    const updateFeedbackButton = useCallback(
        (
            item: getConversation_conversations_data_messages,
            element: getConversation_conversations_data_messages_elements,
        ) => {
            setTimeout(() => {
                const reduxMessage = getReduxStoreValue({
                    reducerName: 'chat',
                    stateName: 'messages',
                    key: currentConversationId,
                });
                const updatedMessages = reduxMessage.map((message) => {
                    if (message.taffiId === item.taffiId) {
                        return { ...message, answer: element.value };
                    }
                    return message;
                });
                dispatch(
                    updateReduxMessages({
                        key: conversation?.id,
                        value: updatedMessages,
                        extraData: {
                            from: 'updateFeedbackButton',
                        },
                    }),
                );
            }, 0);
        },
        [conversation?.id, dispatch, currentConversationId],
    );

    const setElements = useCallback((nextMessage: getConversation_conversations_data_messages): IMessages => {
        const { elements, ...rest } = nextMessage;
        if ((elements?.length && elements[0]?.type === StyleMessageElementTypeEnum.image) || elements?.length === 1) {
            setPendingElements(
                elements?.map((item) => {
                    return { ...item, taffiId: rest.taffiId } as IElements;
                }),
            );
            return rest as IMessages;
        }
        return nextMessage as IMessages;
    }, []);

    const getPageNum = useCallback(() => {
        const defaultPageNum = pageNum.current;
        if (isDisplayArchivedThread && conversationState) {
            return conversationState?.pageNum ?? defaultPageNum;
        } else {
            return defaultPageNum;
        }
    }, [conversationState, isDisplayArchivedThread]);

    const getConversationOnScroll = useCallback(() => {
        if (isStylistView) {
            getConsumerConversation({
                variables: {
                    input: {
                        userId: consumer?.id || '',
                        paging: {
                            orderBy: constant.ORDER_BY.UPDATED_DESC,
                            page: pageNum.current,
                            size: DEFAULT_CONVERSATION_SIZE,
                        },
                    },
                },
            });
        } else {
            getConversationFn({
                variables: {
                    input: {
                        paging: {
                            orderBy: constant.ORDER_BY.UPDATED_DESC,
                            page: getPageNum(),
                            size: DEFAULT_CONVERSATION_SIZE,
                        },
                        lastUpdated: isDisplayArchivedThread ? archivedThreadDate : undefined,
                    },
                },
            });
        }
    }, [
        isStylistView,
        consumer?.id,
        getConsumerConversation,
        getConversationFn,
        isDisplayArchivedThread,
        archivedThreadDate,
        getPageNum,
    ]);

    const renderPreviousConversations = useCallback(
        (scrollTop: boolean) => {
            setTimeout(() => {
                if (messageContainerRef.current) {
                    const scrollHeight = messageContainerRef?.current?.scrollHeight;
                    if (scrollHeight && scrollHeight <= messageContainerRef?.current?.clientHeight) {
                        getConversationOnScroll();
                    } else if (pageNum.current === 1 && scrollTop) {
                        messageContainerRef.current.scrollTop = messageContainerRef?.current?.scrollHeight;
                    }
                }
            }, 100);
        },
        [getConversationOnScroll, messageContainerRef],
    );

    const getReduxStoreValue = ({ reducerName, stateName, key }) => {
        const currentState = store.getState();
        return currentState[reducerName][stateName][key];
    };

    const waitForHeightChangeAndScroll = useCallback((initialHeight: number, retries = 10) => {
        const container = messageContainerRef.current;
        if (!container || retries <= 0) return;

        requestAnimationFrame(() => {
            const currentHeight = container.scrollHeight;

            if (currentHeight !== initialHeight) {
                const scrollPosition = currentHeight - initialHeight - 20;
                container.scrollTo(0, scrollPosition);
                setChatWindowHeight(currentHeight);
            } else {
                setTimeout(() => waitForHeightChangeAndScroll(initialHeight, retries - 1), 50);
            }
        });
    }, []);

    const isConversationIdCreated = useCallback((newConversation) => {
        if (newConversation?.id) {
            return true;
        }
        return false;
    }, []);

    const isUserAskedQuestion = useCallback(
        (newMessages, newConversation = conversation) => {
            const userQuestions = newMessages.filter(
                (message) =>
                    message?.scope === MessageScopeEnum.external &&
                    message.role === MessageRoleEnum.user &&
                    message.type === MessageTypeEnum.conversation,
            );
            if (userQuestions?.length && isConversationIdCreated(newConversation)) {
                return true;
            }
            return false;
        },
        [isConversationIdCreated, conversation],
    );

    const updateChat = useCallback(
        (newConversation: IConversation | null, newMessages: IMessages[], fetch: boolean, single: boolean = false) => {
            const reduxMessage = isDisplayArchivedThread
                ? getReduxStoreValue({
                    reducerName: 'chat',
                    stateName: 'messages',
                    key: ARCHIVED_THREAD,
                }) ?? []
                : isStylistView
                    ? getReduxStoreValue({
                        reducerName: 'chat',
                        stateName: 'messages',
                        key: STYLIST,
                    }) ?? []
                    : newConversation?.id && reduxMessagesRef.current[newConversation?.id]
                        ? getReduxStoreValue({
                            reducerName: 'chat',
                            stateName: 'messages',
                            key: newConversation?.id,
                        })
                        : reduxMessagesRef.current[NEW_THREAD]
                            ? reduxMessagesRef.current[NEW_THREAD]
                            : [];
            if (reduxMessage.length) {
                let updatedMessages: IMessages[] = [];
                reduxMessage.forEach((messageItem) => {
                    let isUpdated = false;
                    newMessages.forEach((newMessageItem) => {
                        if (newMessageItem?.taffiId === messageItem?.taffiId) {
                            updatedMessages = [...updatedMessages, newMessageItem];
                            isUpdated = true;
                        }
                    });
                    if (!isUpdated) {
                        updatedMessages = [...updatedMessages, messageItem];
                    }
                });
                const receivedMessages = differenceBy(newMessages, updatedMessages, 'taffiId');
                if (fetch) {
                    if (single) {
                        const conversationState = getReduxStoreValue({
                            reducerName: 'chat',
                            stateName: 'conversationState',
                            key: newConversation?.id,
                        });
                        const existingMessages = conversationState?.loading ? reduxMessage : updatedMessages;
                        const newMessages: any = [
                            ...existingMessages.filter((item) => !item?.tempMessage),
                            ...receivedMessages,
                        ];
                        const sortedData = newMessages.sort(
                            (a, b) => new Date(a?.created).getTime() - new Date(b?.created).getTime(),
                        );
                        dispatch(
                            updateReduxMessages({
                                key: newConversation?.id,
                                value: sortedData,
                                extraData: {
                                    from: 'update chat: single fetch call',
                                },
                            }),
                        );
                    } else {
                        const container = messageContainerRef.current;
                        const oldScrollHeight = container?.scrollHeight ?? 0;
                        setTimeout(() => {
                            // setMessages([...receivedMessages, ...updatedMessages.filter((item) => !item?.tempMessage)]);
                            dispatch(
                                updateReduxMessages({
                                    key: isStylistView ? STYLIST : newConversation?.id,
                                    value: [
                                        ...receivedMessages,
                                        ...updatedMessages.filter((item) => !item?.tempMessage),
                                    ],
                                    extraData: {
                                        from: 'update chat: fetch without single call',
                                    },
                                }),
                            );
                            waitForHeightChangeAndScroll(oldScrollHeight);
                        }, 100);
                    }
                } else {
                    const receivedUserMessage =
                        receivedMessages.filter((item) => item.role === MessageRoleEnum.user) || [];
                    const receivedAssistantMessages =
                        receivedMessages.filter((item) => item.role !== MessageRoleEnum.user) || [];

                    // if last message is a recommendation message, and received assistant messages contain feedback message, append all received assistant messages to messages array
                    if (
                        messages.length &&
                        messages[messages.length - 1]?.type === MessageTypeEnum.recommendation &&
                        receivedAssistantMessages?.length &&
                        receivedAssistantMessages.some((item) => item?.type === MessageTypeEnum.feedback)
                    ) {
                        // setMessages([
                        //     ...updatedMessages.filter((item) => !item?.tempMessage),
                        //     ...receivedUserMessage,
                        //     ...receivedAssistantMessages,
                        // ]);
                        dispatch(
                            updateReduxMessages({
                                key: newConversation?.id,
                                value: [
                                    ...updatedMessages.filter((item) => !item?.tempMessage),
                                    ...receivedUserMessage,
                                    ...receivedAssistantMessages,
                                ],
                                extraData: {
                                    from: 'update chat: last message is a recommendation',
                                },
                            }),
                        );
                        if (newConversation) {
                            dispatch(
                                updateConversations({
                                    key: newConversation?.id,
                                    value: newConversation,
                                }),
                            );
                        }
                        setTimeout(() => {
                            if (messageContainerRef.current && receivedMessages.length) {
                                messageContainerRef.current.scrollTop = messageContainerRef?.current?.scrollHeight;
                                scrollTopRef.current = messageContainerRef?.current?.scrollTop || 0;
                            }
                        }, 100);
                        return;
                    }

                    let receivedAssistantMessage: IMessages | null = null;
                    if (receivedAssistantMessages?.length) {
                        receivedAssistantMessage = setElements(receivedAssistantMessages[0]);
                    }

                    if (receivedAssistantMessage) {
                        if (isReceivedAssistantMessage && newConversation?.id === currentConversationIdRef?.current) {
                            setPendingMessages(receivedAssistantMessages);
                        } else {
                            if (
                                receivedAssistantMessages?.length > 1 &&
                                newConversation?.id === currentConversationIdRef?.current
                            ) {
                                setPendingMessages(receivedAssistantMessages.filter((item, index) => index > 0));
                            }
                            // setMessages([
                            //     ...updatedMessages.filter((item) => !item?.tempMessage),
                            //     ...receivedUserMessage,
                            //     receivedAssistantMessage,
                            // ]);
                            dispatch(
                                updateReduxMessages({
                                    key: newConversation?.id,
                                    value: [
                                        ...updatedMessages.filter((item) => !item?.tempMessage),
                                        ...receivedUserMessage,
                                        receivedAssistantMessage,
                                    ],
                                    extraData: {
                                        from: 'update chat: receivedAssistantMessage',
                                    },
                                }),
                            );
                            if (receivedAssistantMessage?.language) {
                                setIsReceivedAssistantMessage(true);
                            }
                        }
                    } else {
                        // setMessages([
                        //     ...updatedMessages.filter((item) => !item?.tempMessage),
                        //     ...[...receivedUserMessage],
                        // ]);
                        dispatch(
                            updateReduxMessages({
                                key: newConversation?.id,
                                value: [
                                    ...updatedMessages.filter((item) => !item?.tempMessage),
                                    ...[...receivedUserMessage],
                                ],
                                extraData: {
                                    from: 'update chat: received user message',
                                },
                            }),
                        );
                    }

                    if (newConversation) {
                        dispatch(
                            updateConversations({
                                key: newConversation?.id,
                                value: newConversation,
                            }),
                        );
                    }
                    setTimeout(() => {
                        if (messageContainerRef.current && receivedMessages.length) {
                            messageContainerRef.current.scrollTop = messageContainerRef?.current?.scrollHeight;
                            scrollTopRef.current = messageContainerRef?.current?.scrollTop || 0;
                        }
                    }, 100);
                }
            } else {
                const isOpeningConversation = isUserAuthenticated
                    ? newConversation?.id === `_opening_conversation_${user?.id}`
                    : newConversation?.id?.includes('opening') &&
                      newConversation?.status === StyleConversationStatusEnum.in_conversation;
                if (isDisplayArchivedThread || single) {
                    // setMessages(newMessages);
                    dispatch(
                        updateReduxMessages({
                            key: newConversation?.id,
                            value: newMessages,
                            extraData: {
                                from: 'update chat: without message',
                            },
                        }),
                    );
                    dispatch(
                        updateConversations({
                            key: newConversation?.id,
                            value: newConversation,
                        }),
                    );
                    scrollToBottomOnMessageDisplay();
                } else if (isStylistView) {
                    dispatch(
                        updateCurrentConversationId({
                            value: STYLIST,
                        }),
                    );
                    dispatch(
                        updateReduxMessages({
                            key: STYLIST,
                            value: newMessages,
                            extraData: {
                                from: 'update chat: stylist scenario',
                            },
                        }),
                    );
                    dispatch(
                        updateConversations({
                            key: STYLIST,
                            value: newConversation,
                        }),
                    );
                } else {
                    if (isOpeningConversation && !isUserAskedQuestion(newMessages, newConversation)) {
                        // setMessages(newMessages);
                        dispatch(
                            updateReduxMessages({
                                key: newConversation?.id,
                                value: newMessages,
                                extraData: {
                                    from: 'update chat: opening conversation scenario',
                                },
                            }),
                        );
                        dispatch(
                            updateConversations({
                                key: newConversation?.id,
                                value: newConversation,
                            }),
                        );
                        dispatch(
                            updateCurrentConversationId({
                                value: newConversation?.id,
                            }),
                        );
                    } else if (newConversation) {
                        // updateConversationForNewChat(newConversation);
                    }
                    dispatch(
                        updateIsInitiateNewChat({
                            value: true,
                        }),
                    );
                }
            }
            if (fetch && (isDisplayArchivedThread || isStylistView)) {
                const messageId = queryParams.get('messageTaffiId');
                const productId = queryParams.get('productTaffiId');
                renderPreviousConversations(
                    ![...messages, ...newMessages].find((m) => m?.taffiId === messageId) ||
                        restoredPosition ||
                        !(messageId && productId),
                );
            }
        },
        [
            messages,
            setElements,
            isReceivedAssistantMessage,
            queryParams,
            renderPreviousConversations,
            restoredPosition,
            isDisplayArchivedThread,
            isStylistView,
            isUserAuthenticated,
            user?.id,
            dispatch,
            waitForHeightChangeAndScroll,
            isUserAskedQuestion,
        ],
    );

    const updateSourceConversationId = (conversationId) => {
        const sourceConversationId = localStorage.getItem(WIDGET_CONSTANTS.STYLE_ASSISTANT_SOURCE_CONVERSATION);
        if (sourceConversationId === NEW_THREAD) {
            localStorage.setItem(WIDGET_CONSTANTS.STYLE_ASSISTANT_SOURCE_CONVERSATION, conversationId);
        }
    };

    // Get discover your styles datauseDiscoverYourStyles
    const { listStyles } = useLoaderStyles();

    const canEngagingSliderDisplay = useMemo(() => {
        if (utils.isAppInWidgetMode()) {
            return Boolean(enableEngagingSlider && listStyles?.length);
        }
        return Boolean(ENABLE_ENGAGING_SLIDER && listStyles?.length);
    }, [listStyles, enableEngagingSlider]);

    const isEngagingSliderDisplay = useCallback(
        (message = '') => {
            let loadingMessage = message?.toString();
            return (
                (loadingMessage?.includes('Personalizing recommendations') ||
                    loadingMessage?.includes('تخصيص التوصيات') ||
                    loadingMessage?.includes('Preparing recommendations') ||
                    loadingMessage?.includes('إعداد التوصيات')) &&
                canEngagingSliderDisplay
            );
        },
        [canEngagingSliderDisplay],
    );

    const handleOnComplete = useCallback(
        (response, fetch = false, isSingle = false) => {
            if (fetch) {
                if (isSingle) {
                    updateChat(
                        response?.getSingleConversation,
                        response?.getSingleConversation?.messages,
                        fetch,
                        isSingle,
                    );
                } else if (response?.conversations?.data?.length) {
                    updateChat(response?.conversations?.data[0], response?.conversations?.data[0]?.messages, fetch);
                    pageNum.current = response?.conversations?.paging?.page + 1;
                }
                if (isDisplayArchivedThread) {
                    dispatch(
                        updateConversationState({
                            key: ARCHIVED_THREAD,
                            value: { pageNum: pageNum.current },
                        }),
                    );
                }
            } else {
                // the below updateConversationState it to update the conversation state when the api completes
                const checkEngageSliderStateAndUpdate = () => {
                    if (isEngageSliderPreviewOpenRef.current) {
                        setTimeout(() => {
                            checkEngageSliderStateAndUpdate();
                        }, 500);
                        return;
                    }
                    const updateConversationStateAndMessages = () => {
                        dispatch(
                            updateConversationState({
                                key: response?.conversation?.id,
                                value: { loading: false, loadingMessage: '' },
                            }),
                        );
                        if (response?.conversation?.messages?.length) {
                            // to update the redux state when getting conversationid first time.
                            if (
                                reduxMessagesRef.current[NEW_THREAD] &&
                                !reduxMessagesRef.current[response?.conversation?.id]
                            ) {
                                const updateReduxMessageIfNotPrinting = () => {
                                    if (isMessagePrintingRef.current) {
                                        setTimeout(() => {
                                            updateReduxMessageIfNotPrinting();
                                        }, 500);
                                        return;
                                    }
                                    dispatch(
                                        updateConversations({
                                            key: response?.conversation?.id,
                                            value: response?.conversation,
                                        }),
                                    );
                                    if (!conversation && !currentConversationIdRef.current) {
                                        dispatch(
                                            updateCurrentConversationId({
                                                value: response?.conversation?.id,
                                            }),
                                        );
                                    }
                                    dispatch(
                                        updateReduxMessages({
                                            key: response?.conversation?.id,
                                            value: response?.conversation?.messages,
                                            extraData: {
                                                isRemoveNew: true,
                                                from: 'handleOnComplete: id comes now scenario',
                                            },
                                        }),
                                    );
                                    dispatch(
                                        removeConversationState({
                                            key: NEW_THREAD,
                                        }),
                                    );
                                };
                                updateReduxMessageIfNotPrinting();
                                updateSourceConversationId(response?.conversation?.id);
                            } else if (response?.conversation?.id) {
                                //to update the conversation status whenever an api completes.
                                dispatch(
                                    updateConversations({
                                        key: response?.conversation?.id,
                                        value: response?.conversation,
                                    }),
                                );
                            }
                        }
                    };
                    if (isEngagingSliderDisplay(conversationStateRef.current?.loadingMessage || '')) {
                        setTimeout(() => {
                            updateConversationStateAndMessages();
                        }, 1000);
                    } else {
                        updateConversationStateAndMessages();
                    }
                };
                checkEngageSliderStateAndUpdate();
            }
        },
        [
            updateChat,
            dispatch,
            conversation,
            currentConversationIdRef,
            isDisplayArchivedThread,
            isEngagingSliderDisplay,
        ],
    );

    const handleOnCompleteForStylist = (response, fetch = false) => {
        if (fetch) {
            if (response?.getConsumerConversations?.data?.length) {
                const conversation = response?.getConsumerConversations?.data[0];
                handleStylistAnalytics(TRACK_EVENT.STYLE_CHAT_STYLIST_VIEW, conversation);
                updateChat(conversation, conversation?.messages, fetch);
                pageNum.current = response?.getConsumerConversations?.paging?.page + 1;
            }
        }
    };

    const scrollToBottom = useCallback(() => {
        if (scrollTopRef.current <= (messageContainerRef?.current?.scrollTop || 0)) {
            messageContainerRef.current?.scrollTo(0, messageContainerRef?.current?.scrollHeight);
            scrollTopRef.current = messageContainerRef?.current?.scrollTop || 0;
        }
    }, [messageContainerRef, scrollTopRef]);

    const scrollToBottomOnMessageDisplay = () => {
        setTimeout(() => {
            if (messageContainerRef.current) {
                messageContainerRef.current.scrollTop = messageContainerRef?.current?.scrollHeight;
            }
        }, 100);
    };

    const resetPageNum = () => {
        pageNum.current = 0;
    };

    const updateConversationForNewChat = (conversation) => {
        if (conversation) {
            dispatch(
                updateConversations({
                    key: conversation?.id,
                    value: { ...conversation, status: StyleConversationStatusEnum.new_thread, id: '' },
                }),
            );
        }
    };

    const isNewUserFirstMessage = () => {
        if (
            isUserAuthenticated &&
            conversation?.id === `_opening_conversation_${user?.id}` &&
            conversation?.status === StyleConversationStatusEnum.done &&
            messages?.length === 1
        ) {
            return true;
        }
        return false;
    };

    const canFetchConversationList = () => {
        if (
            !isUserAuthenticated &&
            conversation?.id === `_opening_conversation_${user?.id}` &&
            !isUserAskedQuestion(messages)
        ) {
            //for un-auth users
            return false;
        } else if (
            isUserAuthenticated &&
            conversation?.id === `_opening_conversation_${user?.id}` &&
            !isUserAskedQuestion(messages)
        ) {
            //for auth user
            return false;
        } else if (utils.isAppInWidgetMode() && !utils.isWidgetOpened()) {
            // restrict calling it when widget not even opened
            return false;
        }
        return true;
    };

    const isInitiateNewConveration = useMemo(
        () => isUserAskedQuestion(messages, conversation),
        [isUserAskedQuestion, messages, conversation],
    );

    const isConversationDone = useMemo(() => conversation?.status === StyleConversationStatusEnum.done, [conversation]);
    const updateMessagesWithElements = useCallback(() => {
        let nextPendingElement = pendingElements[0];
        let updatedMessages: any = messages.map((item) => {
            if (item.taffiId === nextPendingElement?.taffiId) {
                return {
                    ...item,
                    elements: item?.elements ? [...item?.elements, nextPendingElement] : [nextPendingElement],
                };
            } else {
                return item;
            }
        });
        if (pendingElements && pendingElements?.length > 1) {
            setPendingElements((prevPendingElements) => [...prevPendingElements.filter((item, index) => index > 0)]);
        } else {
            setPendingElements([]);
        }
        setMessagesWithPendingMessage(updatedMessages);
    }, [messages, pendingElements, setPendingElements]);

    const updateMessages = useCallback(() => {
        setPendingMessageLoading(false);
        // check if last pending message is feedback message
        const lastPendingMessage = pendingMessages[pendingMessages.length - 1];
        if (!ENABLED_SHOW_MORE_STYLES && lastPendingMessage?.type === MessageTypeEnum.feedback) {
            // push all pending messages to messages array
            setMessagesWithPendingMessage([...messages, ...pendingMessages]);
            setPendingMessages([]);
            setIsReceivedAssistantMessage(false);
        } else {
            let nextMessage = setElements(pendingMessages[0]);
            if (pendingMessages?.length > 1) {
                setPendingMessages((prevPendingMessages) => [
                    ...prevPendingMessages.filter((item, index) => index > 0),
                ]);
            } else {
                setPendingMessages([]);
            }
            setMessagesWithPendingMessage([...messages, { ...nextMessage }]);
        }
    }, [setElements, pendingMessages, messages, setPendingMessages]);

    const handleMessageDisplay = useCallback(() => {
        scrollToBottomOnMessageDisplay();
        const TIME_OUT = 1000;
        if (pendingElements?.length && pendingElements[0]?.taffiId !== pendingMessages[0]?.taffiId) {
            setTimeout(() => {
                updateMessagesWithElements();
            }, TIME_OUT);
        } else if (pendingMessages.length) {
            setPendingMessageLoading(true);
            setTimeout(() => {
                updateMessages();
            }, TIME_OUT);
        } else {
            setIsReceivedAssistantMessage(false);
        }
    }, [pendingElements, pendingMessages, updateMessagesWithElements, updateMessages, setIsReceivedAssistantMessage]);

    const sendMessage = useCallback(
        ({
            conversationId = '',
            taffiId = '',
            scope = '' as MessageScopeEnum,
            inAppValue = '',
            inAppMessage = '',
            inAppDynamicMessage = [],
            trendingQuestion = '',
            trendingQuestionLanguage = LanguageCode.english,
            reachLastFeedbackRound = false,
            isIncludeRequestParameter = false,
        }) => {
            startRecommendTime.current = new Date().getTime();
            const tempMessages: IMessages[] = [];
            let tempFeedbackMessage: IMessages | null = null;
            let input: UpdateStyleConversationInput = {};
            if (!(message || inAppValue || trendingQuestion || isCollectingFeedbackReason || reachLastFeedbackRound)) {
                return;
            }
            // Feedback reason collection logic
            if (isCollectingFeedbackReason && feedbackMessageRef?.current) {
                input = {
                    answer: {
                        messageId: feedbackMessageRef.current.taffiId as string,
                        answer: feedbackMessageRef.current.answer ?? FEEDBACK_VALUES.NO,
                        feedbackReason: message || inAppMessage || trendingQuestion, // The text input content
                    },
                };
                handleAnalytics(TRACK_EVENT.STYLE_CHAT_FEEDBACK_NO_CLICKED, {
                    feedbackReason: message || inAppMessage || trendingQuestion,
                    taffiId: feedbackMessageRef.current.taffiId,
                    id: feedbackMessageRef.current.id,
                });
                if (message.length) {
                    tempFeedbackMessage = {
                        content: message,
                        elements: [],
                        role: MessageRoleEnum.user,
                        scope: MessageScopeEnum.external,
                        visible: MessageVisibleEnum.visible,
                        tempMessage: true,
                        created: new Date().toISOString(),
                    } as unknown as IMessages;
                }

                // Reset feedback collection state
                setIsCollectingFeedbackReason(false);
                feedbackMessageRef.current = null;
            } else if (reachLastFeedbackRound) {
                input = {
                    answer: {
                        messageId: taffiId,
                        answer: FEEDBACK_VALUES.NO,
                    },
                };
            } else if (message || inAppMessage || trendingQuestion) {
                input = {
                    message: {
                        content: `${inAppMessage || trendingQuestion || message.trim()}${
                            isIncludeRequestParameter ? ` \n${requestParameters}` : ''
                        }`,
                        dynamicContent: inAppDynamicMessage,
                        scope: scope || MessageScopeEnum.external,
                    },
                };
            }
            if (!conversationId && conversation?.id && conversation?.status !== StyleConversationStatusEnum.done) {
                input = {
                    id: conversation?.id,
                    ...input,
                };
            } else if (conversationId) {
                input.id = conversationId;
            }
            if (scope) {
                input = {
                    ...input,
                    answer: {
                        answer: inAppValue,
                        messageId: taffiId,
                    },
                };
            }
            if (utils.isAppInWidgetMode() && storeId) {
                input = {
                    ...input,
                    storeId: storeId,
                };
            }
            input = {
                ...input,
                numOfStyles: ENABLED_SHOW_MORE_STYLES ? 1 : 5,
            };
            const variables = {
                input,
            };
            const tempMessage: IMessages = {
                content: input?.message?.content as string,
                elements: [],
                role: MessageRoleEnum.user,
                scope: input?.message?.scope ?? MessageScopeEnum.external,
                visible: MessageVisibleEnum.visible,
                tempMessage: true,
                created: new Date().toISOString(),
            } as unknown as IMessages;
            if (tempMessage.content?.length) {
                tempMessages.push(tempMessage);
            }
            if (tempFeedbackMessage) {
                tempMessages.push(tempFeedbackMessage);
            }
            if (trendingQuestion && !selectedQuestion) {
                handleAnalytics(TRACK_EVENT.STYLE_CHAT_TRENDING_QUESTION_CLICKED, {
                    trendingQuestion,
                    language: trendingQuestionLanguage,
                });
            }
            setMessage('');
            if (tempMessages.length) {
                dispatch(
                    updateReduxMessages({
                        key: conversation?.id,
                        value: [...messages, ...tempMessages],
                        extraData: {
                            from: 'send message scenario',
                        },
                    }),
                );
            }
            setTimeout(() => {
                if (messageContainerRef.current && input?.message?.content) {
                    messageContainerRef.current.scrollTop = messageContainerRef?.current?.scrollHeight;
                }
            }, 100);
            dispatch(
                updateConversationState({
                    key: conversation?.id,
                    value: { loading: true },
                }),
            );
            answerMutation({
                variables,
                onCompleted(response) {
                    handleOnComplete(response, false);
                    scrollToBottom();
                },
            });
        },
        [
            message,
            isCollectingFeedbackReason,
            feedbackMessageRef,
            conversation?.id,
            conversation?.status,
            storeId,
            selectedQuestion,
            dispatch,
            answerMutation,
            setIsCollectingFeedbackReason,
            handleAnalytics,
            messages,
            handleOnComplete,
            scrollToBottom,
            requestParameters,
        ],
    );

    const handleShowMore = (
        item: getConversation_conversations_data_messages,
        element: getConversation_conversations_data_messages_elements,
    ) => {
        if (isStylistView || isDisplayArchivedThread) return;
        const messagesExcludePersonalizedStyleExp = messages.filter(
            (m) => m?.type !== MessageTypeEnum.personalized_style_exp,
        );
        const lastMessageExcludePersonalizedStyleExp =
            messagesExcludePersonalizedStyleExp[messagesExcludePersonalizedStyleExp.length - 1];

        const isSendMessageAllowed =
            !conversationState?.loading &&
            !item?.answer &&
            item.taffiId === lastMessageExcludePersonalizedStyleExp.taffiId &&
            conversation?.status === StyleConversationStatusEnum.in_conversation;
        if (isSendMessageAllowed) {
            if (element?.type === StyleMessageElementTypeEnum.show_more_suggestions) {
                handleAnalytics(TRACK_EVENT.STYLE_CHAT_SHOW_MORE_STYLES_CLICKED, {
                    conversationId: conversation?.id,
                });
            }
        }
    };

    const handleScroll = useCallback(() => {
        if (!messageContainerRef.current) return;

        const currentScrollPosition = messageContainerRef.current.scrollHeight - messageContainerRef.current.scrollTop;
        const scrollPositionFromBottom = currentScrollPosition - messageContainerRef.current.clientHeight;
        if (scrollPositionFromBottom > DISPLAY_FLOATING_BUTTON && !displayFloatingButton) {
            setDisplayFloatingButton(true);
        } else if (scrollPositionFromBottom <= DISPLAY_FLOATING_BUTTON && displayFloatingButton) {
            setDisplayFloatingButton(false);
        }
        if (messageContainerRef.current.scrollTop === 0) {
            setChatWindowHeight(() => messageContainerRef?.current?.scrollHeight ?? 0);
            if (isDisplayArchivedThread || isStylistView) getConversationOnScroll();
        }
    }, [displayFloatingButton, getConversationOnScroll, isDisplayArchivedThread, isStylistView]);

    return (
        <ChatContext.Provider
            value={{
                conversation,
                showDynamicItemDetail,
                setShowDynamicItemDetail,
                expandedMessageTaffiIds,
                addExpandedMessageTaffiId,
                isExpandedMessage,
                isReceivedAssistantMessage,
                setIsReceivedAssistantMessage,
                selectedElement,
                setSelectedElement,
                showStylePreview,
                setShowStylePreview,
                isUnlockExpProcessing,
                setIsUnlockExpProcessing,
                openAuthPopup,
                startRecommendTime,
                messageContainerRef,
                handleShowMore,
                answerMutation,
                messages,
                // setMessages,
                message,
                setMessage,
                updateFeedbackButton,
                pageNum,
                chatWindowHeight,
                setChatWindowHeight,
                setElements,
                pendingElements,
                setPendingElements,
                pendingMessages,
                setPendingMessages,
                scrollTopRef,
                renderPreviousConversations,
                getConversationFn,
                getSingleConversationFn,
                messageLoading,
                handleOnComplete,
                handleOnCompleteForStylist,
                consumer,
                setConsumer,
                localUser,
                setLocalUser,
                user,
                userName,
                isUserAuthenticated,
                updateLocalUser,
                getConversationOnScroll,
                restoredPosition,
                setRestoredPosition,
                getConsumerConversation,
                consumerMessageLoading,
                updateChat,
                sendMessage,
                handleAnalytics,
                messagesWithPendingMessage,
                setMessagesWithPendingMessage,
                pendingMessageLoading,
                setPendingMessageLoading,
                scrollToBottomOnMessageDisplay,
                scrollToBottom,
                handleMessageDisplay,
                updateMessagesWithElements,
                updateMessages,
                displayFloatingButton,
                setDisplayFloatingButton,
                handleScroll,
                resetPageNum,
                updateConversationForNewChat,
                isInitiateNewConveration,
                isConversationDone,
                canFetchConversationList,
                conversationState,
                getReduxStoreValue,
                isNewUserFirstMessage,
                updateSourceConversationId,
                isCollectingFeedbackReason,
                setIsCollectingFeedbackReason,
                feedbackMessageRef,
                requestParameters,
                setRequestParameters,
                isEngageSliderPreviewOpen,
                setIsEngageSliderPreviewOpen,
                isEngageSliderPreviewOpenRef,
                isEngagingSliderDisplay,
                listStyles,
                canEngagingSliderDisplay,
                waitingRecommendationMessage,
            }}
        >
            {children}
        </ChatContext.Provider>
    );
};

export const useChatContext = () => {
    const context = useContext(ChatContext);
    if (context === undefined) {
        throw new Error('useChatContext must be used within a ChatProvider');
    }
    return context;
};
